export const base64File = (file: File): Promise<string> => {
  return new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const [, data] = (reader.result as string).split('base64,');
      if (data === undefined) {
        reject(new Error('Invalid data URL: missing base64 payload'));
        return;
      }
      resolve(data);
    };
    reader.onerror = () =>
      reject(reader.error ?? new Error('Failed to read file'));
  });
};
